export let hres8axColumns = () => {
  let detailDeductionTable1Columns = [{
    key: 'desc_coddeduct',
    name: '',
    labelCodapp: 'HRES8AXC2',
    labelIndex: '20',
    style: 'min-width: 300px;'
  }, {
    key: 'amtdeduct',
    name: '',
    labelCodapp: 'HRES8AXC2',
    labelIndex: '30',
    class: 'align-right',
    style: 'min-width: 100px;',
    inlineType: 'number'
  }]

  let detailDeductionTable2Columns = [{
    key: 'desc_coddeduct',
    name: '',
    labelCodapp: 'HRES8AXC2',
    labelIndex: '20',
    style: 'min-width: 300px;'
  }, {
    key: 'amtdeduct',
    name: '',
    labelCodapp: 'HRES8AXC2',
    labelIndex: '40',
    class: 'align-right',
    style: 'min-width: 100px;',
    inlineType: 'number'
  }]

  return {
    en: {
      detailDeductionTable1: detailDeductionTable1Columns,
      detailDeductionTable2: detailDeductionTable2Columns
    },
    th: {
      detailDeductionTable1: detailDeductionTable1Columns,
      detailDeductionTable2: detailDeductionTable2Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres8ax.js